<template>
  <div class="pagination-wrapper">
    <ul class="pagination">
      <li v-for="page in pages" :key="page"><Button @click="setPage(page)" :primary="page === value">{{ page }}</Button></li>
    </ul>
    <span>{{ $t('Aantal items') }}: #{{ total }}, {{ perPage }} {{ $t('per pagina') }}</span>
  </div>
</template>

<script>
import Button from './Button'
import { scrollTo } from '../../utils'
export default {
  name: 'Pagination',
  components: {
    Button
  },
  props: {
    perPage: Number,
    total: Number,
    value: Number
  },
  computed: {
    pages () {
      return Array.from({ length: Math.ceil(this.total / this.perPage) }, (x, i) => i + 1)
    }
  },
  methods: {
    setPage (page) {
      if (this.value !== page) {
        this.$emit('input', page)
        scrollTo()
      }
    }
  }
}
</script>

<style lang="scss">
.pagination-wrapper {
  align-items: center;
  display: flex;
  flex-wrap: wrap;

  > span {
    margin-bottom: 1rem;
  }
}
.pagination {
  display: flex;
  margin-right: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;

  li:not(:last-child) {
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
  }
}
</style>
